<template>
  <CHeader fixed light>
    <CToggler in-header class="ml-3 d-lg-none" @click="$store.commit('toggleSidebarMobile')" />
    <CToggler in-header class="ml-3 d-md-down-none" @click="$store.commit('toggleSidebarDesktop')" />
    <CHeaderBrand class="mx-auto d-lg-none" to="/"> </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto"> </CHeaderNav>
    <CHeaderNav v-if="scrapeStatus" class="mr-4">
      <CHeaderNavItem><span v-html="scrapeStatus"></span></CHeaderNavItem>
    </CHeaderNav>
  </CHeader>
</template>

<script>
import moment from "moment";
import { scraperService } from "../services/services";

export default {
  name: "TheHeader",
  data() {
    return {
      getStatusTimeout: null,
    };
  },
  mounted() {
    moment.locale("hr");
    this.getStatus();
  },
  computed: {
    scrapeStatus() {
      let errorMessage = this.$store.state.messages.find((m) => m.type === "error");
      if (errorMessage) {
        return moment(errorMessage.date).fromNow() + ": " + errorMessage.text;
      }

      let infoMessage = this.$store.state.messages.find((m) => m.type === "info");
      if (infoMessage) {
        return moment(infoMessage.date).fromNow() + ": " + infoMessage.text;
      }

      let lastMessage = this.$store.state.messages[0];
      if (lastMessage) {
        return moment(lastMessage.date).fromNow() + ": " + lastMessage.text;
      }
    },
  },
  beforeDestroy() {
    if (this.getStatusTimeout) clearTimeout(this.getStatusTimeout);
  },
  methods: {
    getStatus() {
      let self = this;
      scraperService.getStatus().then((r) => {
        let messages = r.body;
        messages.forEach((m) => {
          if (typeof m.text === "string") {
            let captchaMessageParts = m.text.split("Captcha page; url: ");
            if (captchaMessageParts.length === 2) {
              m.text = `error: <a href='${captchaMessageParts[1]}' target="_blank" rel="noopener noreferrer">Captcha page</a>`;
              if (this.$store.state.messages.length > 0 && messages.length > 0) {
                let isScrapeFinished = !this.$store.state.messages[0].text.startsWith("job zavrsen") && messages[0].text.startsWith("job zavrsen");
                if (isScrapeFinished) {
                  window.open(captchaMessageParts[1], "_blank");
                }
              }
            } else {
              if (m.text.length > 200) {
                m.text = m.text.slice(0, 200) + " ...";
              }
            }
          }
        });
        this.$store.commit("set", ["messages", messages]);
        this.getStatusTimeout = setTimeout(() => {
          self.getStatus();
        }, 5000);
      });
    },
  },
};
</script>
